// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-wrapper-table-custom-sort-icon .mat-icon {
  height: 100%;
  width: 16px;
  font-size: 15px;
  margin-right: 8px;
  color: var(--fi-color-filter-grey-light);
  transition: 0.2s;
}
.fi-wrapper-table-custom-sort-icon .mat-icon,
.fi-wrapper-table-custom-sort-icon .header-label {
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-wrapper-table/cells/fi-wrapper-table-custom-sort-icon/fi-wrapper-table-custom-sort-icon.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,wCAAA;EACA,gBAAA;AAAR;AAEI;;EAEI,sBAAA;AAAR","sourcesContent":[".fi-wrapper-table-custom-sort-icon {\r\n    .mat-icon {\r\n        height: 100%;\r\n        width: 16px;\r\n        font-size: 15px;\r\n        margin-right: 8px;\r\n        color: var(--fi-color-filter-grey-light);\r\n        transition: 0.2s;\r\n    }\r\n    .mat-icon,\r\n    .header-label {\r\n        vertical-align: middle;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
